import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const HamburgerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="hamburger-menu">
      {/* Hamburger Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="hamburger-button p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400"
      >
        {isOpen ? <X size={24} /> : <Menu size={24} />}
      </button>
      
      {/* Dropdown Menu with toggle class */}
      <div className={`menu-dropdown ${isOpen ? "open" : ""}`}>
        <Link to="/reader" onClick={() => setIsOpen(false)}>
          Reader
        </Link>
        <Link to="/features" onClick={() => setIsOpen(false)}>
          Feature Matrix
        </Link>
        <Link to="/article" onClick={() => setIsOpen(false)}>
          Article
        </Link>
      </div>
    </div>
  );
};

export default HamburgerMenu;